import React from 'react';

import {
  SortieVehiculeRequestDto,
  SortieVehiculeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { SelectMotifSortieUsingIdCorrelation } from 'components/WrappedComponents/Form/FormFields/Select/Referentiels/MotifSortie';
import { useApi } from 'hooks/ApiStoreContext';
import { SortieVehicule } from 'types/SortieVehicule';

import {
  generateSortieVehiculeRequestDtoFromSortieVehicule,
  validateSortieVehiculeRule,
} from '../utils';

import { SortieVehiculeFieldsProps } from './types';

function SelectMotif({
  values,
  dossierId,
}: SortieVehiculeFieldsProps): React.ReactElement {
  const { GardienFourriereControllerApi: gfController } = useApi();
  const key: keyof SortieVehicule = 'motifSortieIdCorrelation';

  return (
    <SelectMotifSortieUsingIdCorrelation
      values={values}
      fieldKey={key}
      validator={async value => {
        const sortieVehiculeRequestDto: SortieVehiculeRequestDto =
          generateSortieVehiculeRequestDtoFromSortieVehicule({
            ...values,
            [key]: value,
          });
        return await validateSortieVehiculeRule(
          dossierId,
          gfController,
          sortieVehiculeRequestDto,
          SortieVehiculeViolationDtoFormFieldEnum.MOTIF_SORTIE,
        );
      }}
    />
  );
}

export default SelectMotif;
